import styled from 'styled-components';

export const StyledError = styled.div`
  color: ${({ theme }) => theme.colors.lightDanger};
  text-align: center;
  font-size: 14px;
  strong {
    color: inherit;
    font-size: 16px;
    font-weight: bold;
    display: block;
  }
  span {
    color: inherit;
    display: block;
  }
`;

export const SearchPanel = styled.div`
  border-radius: 2px;
  display: flex;
  flex-direction: column;
  max-width: 100%;

  .ellington-cards .default-type-root-header {
    background: ${({ theme }) => theme.colors.success};
  }
`;

export const SearchHeader = styled.div``;

export const SearchBody = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors.background};
  padding: 10px;
`;

export const CenteredBox = styled.div`
  display: flex;
  flex-grow: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const IconButton = styled.button`
  background: transparent;
  padding: 0;
  margin: 0;
  outline: 0;
  border: 0;
  line-height: 0px;
  display: inline-block;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.secondaryLink};
`;

export const CloseButton = styled(IconButton)`
  position: absolute;
  right: 10px;
  top: 10px;
`;
